// Import react elements
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Import core functions
import { updatePassword } from "api/APICoreCalls";

// Import global hooks
import useFormHandler from "global/hooks/useFormHandler";

// Import components
import CreateButton from "global/components/CreateButton";

// Import icons
import { ShowAllIcon } from "global/icons/GlobalIcons";

// Import utility functions
import { DisplayConfirmationDialog } from "global/utilities/DialogBox";
import { SetCookie } from "global/utilities/Cookies";

// Import css style sheet
import styles from "../LoginPage.module.css";



const UpdatePasswordForm = ({ onSwitch }) => {



    // Set navigate to useNavigate() which provides a function to programmatically navigate between routes
    const navigate = useNavigate();

    // Store whether each password field should be visible
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);



    // Set location to useLocation() which gives access to the current URL/location object
    const location = useLocation();



    // Set params from the url parameters
    const params = new URLSearchParams(location.search);



    // Set urlToken to the token in the url path
    const urlToken = params.get("token");



    // Set urlEmail to the email in the url path
    const urlEmail = params.get("email");



    // Extract form-related state and functions from the `useFormHandler` custom hook
    const {

        formValues,     // Stores the current values of form inputs
        handleChange,   // Function to update form values when inputs change
        handleSubmit,   // Function to handle form submission logic
        fieldErrors,    // Object storing validation errors for individual fields
        formError,      // General error message (e.g. API errors)
        loading,        // Boolean indicating whether the form is submitting
        apiResponse,    // Stores the response from the API after submission

    } = useFormHandler({

        // Default values for the form fields
        initialValues: {

            password: "",
            confirmPassword: "",
            email: urlEmail,
            token: urlToken,

        },

        // API function to be called on form submission
        apiCall: updatePassword,

        // Don't pass the logged-in auth token because this reset uses the token from the URL
        passTokenToAPI: false,

        // Validation function to check the form fields before submission
        validate: (values) => {

            // Set errors to empty
            const errors = {};

            // Validation rules
            if (values.password.length < 6) errors.password = "Password must be at least 6 characters";
            if (values.password !== values.confirmPassword) errors.confirmPassword = "Passwords must match";

            // Return validation errors (if any)
            return errors;
        },
    });



    // useEffect runs whenever `apiResponse` changes
    useEffect(() => {

        // Check if there is a response
        if (apiResponse) {

            // There is so check if it's a successful response
            if (apiResponse.success) {

                // It is so display a confrimation dialog
                DisplayConfirmationDialog(

                    // Dialog message
                    "Password updated, please log in.",

                    // Confirm button title
                    "OK",

                    // Cancel button title - empty because we don't want a cancel button
                    "",

                    // Returned response from the dialog box
                    function (is_confirmed) {

                        // Check if the response is TRUE
                        if (is_confirmed) {

                            // It is

                            // Set the prefill email cookie
                            SetCookie("prefill_email", urlEmail, 1);

                            // Navigate to the login page
                            navigate("/login");

                        }

                    }
                );

            }
        }

    }, [apiResponse, navigate, urlEmail]);



    return (

        <div className="form-container">

            <h2>Update Password</h2>

            <br />

            <form onSubmit={handleSubmit}>

                <div className={styles.login_password_input_wrap}>

                    <input
                        name="password"
                        type={showPassword ? "text" : "password"}
                        placeholder="New Password"
                        value={formValues.password || ""}
                        onChange={handleChange}
                    />

                    <button
                        type="button"
                        className={styles.login_password_toggle}
                        onClick={() => setShowPassword(!showPassword)}
                        title={showPassword ? "Hide password" : "Show password"}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                    >
                        <ShowAllIcon />
                    </button>

                </div>

                {fieldErrors.password && <p style={{ color: "red" }}>{fieldErrors.password}</p>}

                <br />
                <br />

                <div className={styles.login_password_input_wrap}>

                    <input
                        name="confirmPassword"
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm New Password"
                        value={formValues.confirmPassword || ""}
                        onChange={handleChange}
                    />

                    <button
                        type="button"
                        className={styles.login_password_toggle}
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        title={showConfirmPassword ? "Hide password" : "Show password"}
                        aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                    >
                        <ShowAllIcon />
                    </button>

                </div>

                {fieldErrors.confirmPassword && <p style={{ color: "red" }}>{fieldErrors.confirmPassword}</p>}

                {formError && <p style={{ color: "red" }}>{formError}</p>}

                <br />
                <br />

                <CreateButton title={loading ? "Updating Password..." : "Update Password"} size="l" fullWidth="true" color="#1597e5" type="submit" disabled={loading} />

            </form>

            <br />
            <br />

            <p>
               ◂ <span onClick={() => onSwitch("login")} style={{ cursor: "pointer" }}><b>Back to login</b></span>
            </p>
            
        </div>

    );
    
};

export default UpdatePasswordForm;